<template>
  <div v-loading="loading" class="YiXinApplicationPreview">
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel">标题:</td>
          <td>{{application.title}}</td>
          <td class="tableLabel">编号:</td>
          <td>{{application.applicationNo}}</td>
          <td class="tableLabel">申请人:</td>
          <td>{{application.creatorName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">申请公司:</td>
          <td>{{application.customerName}}</td>
          <td class="tableLabel">申请日期:</td>
          <td>{{application.createTime}}</td>
          <td class="tableLabel">申请部门:</td>
          <td>{{application.departmentName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">合同单位全称:</td>
          <td>{{application.unitCustomerName}}</td>
          <td class="tableLabel">出厂日期:</td>
          <td>{{application.outFactoryDate}}</td>
          <td class="tableLabel">合同编号:</td>
          <td>{{application.clientContractNo}}</td>
        </tr>
        <tr>
          <td class="tableLabel">客户要求交货期:</td>
          <td>{{application.deliveryDate}}</td>
          <td class="tableLabel">发货金额:</td>
          <td>{{application.shipmenAmount}}</td>
          <td class="tableLabel">新老客户:</td>
          <td>
            <span v-if="application.oldCustomer === true">老客户</span>
            <span v-if="application.oldCustomer === false">新客户</span>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">是否冲销:</td>
          <td>
            <span v-if="application.writeOff === true">是</span>
            <span v-if="application.writeOff === false">否</span>
          </td>
          <td class="tableLabel">冲销对应PC号:</td>
          <td>{{application.writeOffFactoryNos}}</td>
          <td class="tableLabel">是否正式报关:</td>
          <td>
            <span v-if="application.declareCustoms === true">是</span>
            <span v-if="application.declareCustoms === false">否</span>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">报关金额:</td>
          <td>{{application.declareCustomsAmount}}</td>
          <td class="tableLabel">付款方式:</td>
          <td>{{application.payment}}</td>
          <td class="tableLabel">合同约定运输方式:</td>
          <td>{{application.contractShipmentType}}</td>
        </tr>
        <tr>
          <td class="tableLabel">DHL费用承担方:</td>
          <td>{{application.dHLShipmentBelong}}</td>
          <td class="tableLabel">包装要求:</td>
          <td>{{application.packRequirement}}</td>
          <td class="tableLabel">品类:</td>
          <td>{{application.category}}</td>
        </tr>
        <tr>
          <td class="tableLabel">评审交期:</td>
          <td>{{application.reviewDeadline}}</td>
          <td class="tableLabel">供货公司:</td>
          <td>
            <el-checkbox-group v-model="application.supplyCompanyList" disabled>
              <el-checkbox label="电气"/>
              <el-checkbox label="外购"/>
            </el-checkbox-group>
          </td>
          <td class="tableLabel">订仓日期:</td>
          <td>{{application.bookingDate}}</td>
        </tr>
        <tr>
          <td class="tableLabel">实际收款情况:</td>
          <td>{{application.actualCharges}}</td>
          <td class="tableLabel">币种名称:</td>
          <td>{{application.currencyName}}</td>
          <td class="tableLabel">进仓日期:</td>
          <td> {{application.warehouseDate}}</td>
        </tr>
        <tr>
          <td class="tableLabel">进仓地址:</td>
          <td>{{application.warehouseAddress}}</td>
          <td class="tableLabel">联系人:</td>
          <td>{{application.warehouseContact}}</td>
          <td class="tableLabel">联系电话:</td>
          <td>{{application.warehousePhone}}</td>
        </tr>
        <tr>
          <td class="tableLabel">最终客户</td>
          <td>{{application.finalCustomerName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">出厂编号:</td>
          <td colspan="5" type="textarea">{{application.factoryNos}}</td>
        </tr>
      </table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        发货明细
      </div>
      <div style="color: #2d8cf0; font-size: 12px; margin-left: 1%; cursor: pointer" @click="changeDetailShow()">
        {{isShowDetail ? "隐藏" : "展开"}}
        <el-button style="padding: 1px 2px" :icon="isShowDetail ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
      </div>
      <el-table
          v-if="isShowDetail"
          ref="payData1"
          :data="application.detailList">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="techParamBillNo" align="center" label="出厂编号" width="100"/>
        <el-table-column prop="invoiceNo" align="center" label="发货单" width="100"/>
        <el-table-column prop="salesOrderNo" align="center" label="销售订单" width="100"/>
        <el-table-column prop="materialCode" align="center" label="物料编号" width="250"/>
        <el-table-column prop="materialName" align="center" label="物料名称"/>
        <el-table-column prop="salesOrderQty" align="center" label="销单数量" width="100"/>
        <el-table-column prop="quantity" align="center" label="发货数量" width="150"/>
        <el-table-column prop="unitPrice" align="center" label="含税单价" width="100"/>
        <el-table-column prop="totalPrice" align="center" label="含税总价" width="100"/>
        <el-table-column prop="type" align="center" label="发货类别" width="100"/>
      </el-table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        订单附件
      </div>
      <el-button
          type="primary"
          style="margin-bottom:5px"
          :loading="downLoadLoading"
          @click="downloadAll">
        下载所有附件
      </el-button>
      <el-table ref="payData1" border :data="application.accessoryList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" width="750"/>
        <el-table-column label="下载" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip/>
      </el-table>
    </div>
    <handle-detail v-if="billId" :bill-id="billId" :bill-type="billType" :sequ-id="'-1'"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "YiXinApplicationPreview",
    components: {HandleDetail},
    data() {
      return {
        priceAuth: this.$auth(417),
        loading: false,
        billType: "33",
        billId: "",
        downLoadLoading: false,
        flag: true,
        isShowDetail: true,
        isShowPack: true,
        application: {},
        uploadLoading: false,
      };
    },
    watch: {
      $route: {
        handler: function(val) {
          if (val.name === "YiXinApplicationPreview") {
            this.getData(this.$route.query.billId);
          }
        },
      },
    },

    created() {
      this.getData(this.$route.query.billId);
    },
    methods: {
      // 根据销售订单id查询详细信息
      getData(pkid) {
        this.billId = pkid;
        this.$http.get("basic", "YiXinShipmentApplication/" + pkid).then((resp) => {
          this.application = resp;
        });
      },

      downloadAll() {
        if (this.application.accessoryList.length === 0) {
          this.$message.error("没有可下载的附件！");
        }
        for (let item of this.application.accessoryList) {
          this.download(item);
        }
      },
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      changeDetailShow() {
        this.isShowDetail = !this.isShowDetail;
      },

      changePackShow() {
        this.isShowPack = !this.isShowPack;
      },
    },
  };
</script>
<style lang="scss">
@media (max-width: 1280px) {
  .YiXinApplicationPreview {
    width: 97%;
    overflow-x: scroll;
  }
}

.YiXinApplicationPreview {
  .el-table th {
    background: #d1e6f5;
    height: 34px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #dddddd;
    border-bottom: none;
  }

  table.gridtable th {
    text-align: left;
    padding: 8px;
    background-color: #d1e6f5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    border-top: none;
    border-right: none;
    min-width: 150px;
  }

  .tableLabel {
    width: 120px;
    text-align: left;
    background-color: #d1e6f5;
  }

  .el-button {
    margin-left: 0 !important;
    margin-right: 5px !important;
  }
}
</style>
